export enum ScheduledBookingTypeEnum{
    League = 1,
    ServiceMaintenance = 2,
    Lesson = 3,
    Tournament = 4,
    Event = 5,
    Other = 6
}

export const ScheduledBookingTypeEnumLabel = [
    { type: ScheduledBookingTypeEnum.League, name: 'League', description: 'Regular league play' },
    { type: ScheduledBookingTypeEnum.ServiceMaintenance, name: 'Service/Maintenance', description: 'Equipment maintenance and service' },
    { type: ScheduledBookingTypeEnum.Lesson, name: 'Lesson', description: 'Golf instruction and lessons' },
    { type: ScheduledBookingTypeEnum.Tournament, name: 'Tournament', description: 'Competitive events' },
    { type: ScheduledBookingTypeEnum.Event, name: 'Event', description: 'Corporate events, birthdays, etc.' },
    { type: ScheduledBookingTypeEnum.Other, name: 'Other', description: 'Other' }
]